import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface autoResize {
  autoResize?: boolean;
}

const Span = styled.span<autoResize>`
  padding: ${props =>
    props.autoResize ? '19.5px 0 !important' : '12px 5px 12px 3px !important'};
`;

interface StateProps {
  path?: string;
  icon?: ReactNode;
  label: string;
  className?: string;
  onClick?: Function;
  autoResize?: boolean;
}

type Props = StateProps;

const menuItem = ({
  path,
  icon,
  label,
  className,
  // @ts-ignore
  onClick,
  autoResize,
}: StateProps) => (
  <li
    // @ts-ignore
    className={className}
    // @ts-ignore
    onClick={onClick}
  >
    <Link
      // @ts-ignore
      to={path}
    >
      <i className="">{icon}</i>
      <Span autoResize={autoResize} className="pr-10px">
        {label}
      </Span>
    </Link>
  </li>
);

export default menuItem;
